// extracted by mini-css-extract-plugin
export default {"card":"pokemon_card__BTLwv","title_card":"pokemon_title_card__oT9iB","container_types":"pokemon_container_types__USOm1"};